import assert from 'assert';
import typeCheck from 'common/util/typeCheck';
import { USER_ROLE_LIMITED_TOURS, hasRoleLimitedTours } from 'common/userRoles';
import { shouldUserHaveRoleLimitedTours } from 'common/householdApplication/prequalificationHelpers';
import { FRONT_TAG_LIMITED_TOURS } from 'common/frontConstants';
import { SR_API_ACTION_UPDATE_RENTER_FRONT_TAGS } from 'api/actionTypes';
import updateUser from 'client/actions/User/update';
import postWithState from 'client/actions/postWithState';

export default async function updateCurrentUserRoleLimitedToursIfNeeded(
  { state, apiClient },
  { renterProfile },
) {
  const currentUser = state.get(['currentUser']);
  const marketsById = state.get(['markets', 'byId']);
  const market = marketsById[currentUser.searchFilters.marketId];
  typeCheck('renterProfile::NonEmptyObject', renterProfile);
  assert(renterProfile.userId === currentUser.id, 'Update roles only for current user.');

  const currentUserRoles = state.get(['currentUser', 'roles']);
  const shouldCurrentUserHaveRoleLimitedTours = shouldUserHaveRoleLimitedTours({ renterProfile });

  if (
    market &&
    hasRoleLimitedTours(currentUserRoles) &&
    !shouldCurrentUserHaveRoleLimitedTours &&
    !market.prequalRemovesLimitedToursRole
  ) {
    return;
  }

  if (market && !market.limitedToursEnabled) {
    return;
  }

  if (shouldCurrentUserHaveRoleLimitedTours !== hasRoleLimitedTours(currentUserRoles)) {
    updateUser(
      { state, apiClient },
      {
        roles: shouldCurrentUserHaveRoleLimitedTours
          ? [...currentUserRoles, USER_ROLE_LIMITED_TOURS]
          : currentUserRoles.filter((userRole) => userRole !== USER_ROLE_LIMITED_TOURS),
      },
    );
    const updateRenterTagsPayload = {
      userId: currentUser.id,
      tagsToAdd: [],
      tagsToRemove: [],
    };
    if (shouldCurrentUserHaveRoleLimitedTours) {
      updateRenterTagsPayload.tagsToAdd.push(FRONT_TAG_LIMITED_TOURS);
    } else {
      updateRenterTagsPayload.tagsToRemove.push(FRONT_TAG_LIMITED_TOURS);
    }

    postWithState(
      { state, apiClient },
      {
        action: SR_API_ACTION_UPDATE_RENTER_FRONT_TAGS,
        payload: updateRenterTagsPayload,
      },
    );
  }
}
